<template>
  <funding-base :state="state" :current-funding-pot-id="state.funding_pot.id">
    <div class="container mt-12">
      <ul class="list-reset">
        <li
          v-for="competition in state.funding_pot.competitions"
          :key="competition.uuid"
          class="mb-8"
        >
          <admin-dashboard-funding-pot-competition
            :competition="competition"
          />
        </li>
      </ul>
    </div>
  </funding-base>
</template>

<script>
export default {
  name: 'FundingCompetitionsIndex'
}
</script>
